var map = {
	"./copy.svg": "22d4",
	"./mail.svg": "64c2",
	"./notification.svg": "bf8c",
	"./phone.svg": "b546",
	"./telegram.svg": "dedc",
	"./viber.svg": "8ee4",
	"./vk.svg": "7faa",
	"./whatsapp.svg": "ca52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0062";